import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { daysOfWeek } from "src/app/app.const";
import { User } from "src/app/core/endpoints/models/user.model";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { Extra } from "src/app/core/endpoints/models/extra";

@Component({
	selector: "app-extras",
	templateUrl: "./extras.component.html",
	styleUrls: ["./extras.component.scss"],
})
export class ExtrasComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;
	@ViewChild("fileInput") fileInput: any;

	public schedules: any[] = [];
	public extras: Extra[] = [];
	public loading: boolean = false;
	public dialogExtra: boolean = false;
	public extraSelected: Extra;
	public mode: "edit" | "register" = "edit";
	public photo: File[] = [];
	public stringPhoto: any[] = [];
	public mainPhoto: File;
	public mainStringPhoto: any;
	public photosToDelete: any[] = [];
	public daysOfWeek = daysOfWeek;
	public dialogSchedule: boolean = false;
	public cropping: boolean = false;
	public pictureCrop: any;
	public imageChangedEvent: any = "";
	loggedUser : any;

	form: FormGroup = this.fb.group({
		name: ["", Validators.required],
		images: [""],
		image: [""],
		price: ["", Validators.required],
		description: ["", Validators.required],
		deleted_photos: [""]
	});

	constructor(
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		private apiService: ApiService,
		private fb: FormBuilder,
		private authService: AuthenticationService,
	) {
		this.loggedUser = this.authService.getUser();
	}

	ngOnInit(): void {
		this.loadExtras();
	}
	
	getUser() {
		return AuthService.getDataUser();
	}

	/**
	 * Resetear formulario
	 */
	public resetForm() {
		this.form.reset();
		this.photo = undefined;
		this.stringPhoto = undefined;
		this.mainPhoto = undefined;
		this.mainStringPhoto = undefined;
		this.photosToDelete = undefined;
		this.pictureCrop = undefined;
	}
	/**
	 * Limpiar filtros de búsqueda
	 * @param table
	 */
	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}

	/**
	 * Mostrar modal de creación/edición de servicio
	 * @param extra
	 */
	public showDialog(extra?: any) {
		this.mode = extra ? "edit" : "register";
		this.photo = [];
		this.stringPhoto = [];

		if (extra) {
			console.log(extra)
			this.photosToDelete = [];
			this.extraSelected = extra;
			this.form.patchValue(extra);
			// this.stringPhoto = extra.images
			// 	? extra.images?.map((element) => ({
			// 			id: element.id,
			// 			image: element.image,
			// 	  }))
			// 	: [];
			this.pictureCrop = extra.image;
		}
		this.dialogExtra = true;
	}

	/**
	 * Cargar listado de extras
	 */
	public loadExtras() {
		this.loading = true;
		this.apiService.getEntity("extras").subscribe({
			next: (result) => {
				this.extras = result.extras;
				this.loading = false;
			},
			error: (err) => {
				console.log(err);
				this.loading = false;
				this.toast.show(
					"Error",
					"Ocurrió un error obteniendo el listado de extras, inténtelo de nuevo",
					"error"
				);
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	/**
	 * Enviar formulario de registro/edición de servicio
	 */
	public async registerExtra() {
		this.form.markAllAsTouched();
		
		// if (this.stringPhoto.length === 0) {
		// 	return this.toast.show(
		// 		"Aviso",
		// 		"Añada al menos una imagen al carrusel",
		// 		"warn"
		// 	);
		// }

		if (this.mainStringPhoto === null || this.mainStringPhoto === "") {
			return this.toast.show("Aviso", "Añada una imagen principal", "warn");
		}

		if (this.form.invalid) {
			console.log(this.form.errors);
			this.form.markAllAsTouched();
			return this.toast.show("Aviso", "Revise el formulario", "warn");
		}

		const formValue = this.form.value;
		const formData = new FormData();

		formData.append("name", formValue.name.toString());
		formData.append("price", formValue.price.toString());
		formData.append("description", formValue.description.toString());
		formData.append("image", this.pictureCrop);
		// let images = [];
		// for (const image of this.photo) {
		// 	formData.append("images[]", image);
		// }

		// if (this.photosToDelete) {
		// 	for (const image of this.photosToDelete) {
		// 		formData.append("deleted_photo[]", image);
		// 	}
		// }
		
		this.loading = true;

		if (this.mode === "register") {
			this.apiService.addEntityFormData("registerExtra", formData).subscribe({
				next: (result) => {
					this.toast.show("Servicio registrado correctamente");
					this.loading = false;
					this.dialogExtra = false;
					this.cropping = false;
					this.loadExtras();
				},
				error: (err) => {
					console.log(err);
					this.loading = false;
					this.cropping = false;
					this.toast.show(
						"Error",
						"Ocurrió un error al registrar el servicio, inténtelo de nuevo",
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		} else {
			formData.append("id", this.extraSelected.id.toString());
			this.apiService.addEntityFormData("updateExtra", formData).subscribe({
				next: (result) => {
					this.toast.show("Servicio actualizado correctamente");
					this.loading = false;
					this.dialogExtra = false;
					this.cropping = false;
					this.loadExtras();
				},
				error: (err) => {
					console.log(err);
					this.loading = false;
					this.cropping = false;
					this.toast.show(
						"Error",
						"Ocurrió un error al actualizar el servicio, inténtelo de nuevo",
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
		}
	}

	/**
	 * Eliminar servicio seleccionado
	 */
	public deleteExtra(extra: Extra) {
		if (this.loading) return;
		this.confirmationService.confirm({
			header: 'Eliminar servicio',
			message: "¿Está seguro que desea eliminar este servicio?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.deleteEntity("deleteExtra", extra.id).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Servicio eliminado correctamente");
						this.loadExtras();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Aviso",
							"Ocurrió un error intentando eliminar el servicio, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}

	/**
	 * Manejador de imágenes
	 * @param $event
	 * @returns
	 */
	public handleUpload() {
		const files = this.fileInput.nativeElement.files;

		if (files && files.length) {
			for (let i = 0; i < files.length; i++) {
				const file = files[i];

				// Verificar el formato del archivo
				const allowedFormats = ["image/jpeg", "image/png"];
				if (allowedFormats.includes(file.type)) {
					// Verificar el número máximo de fotos
					if (this.stringPhoto.length < 5) {
						this.photo.push(file);
						const reader = new FileReader();
						reader.onload = (event: any) => {
							const imageUrl = event.target.result;
							this.stringPhoto.push({
								image: imageUrl,
							});
						};
						reader.readAsDataURL(file);
					} else {
						return this.toast.show(
							"Aviso",
							"Añada un máximo de cinco imágenes",
							"warn"
						);
					}
				} else {
					return this.toast.show(
						"Aviso",
						"El formato de la imagen debe ser PNG o JPG",
						"warn"
					);
				}
			}
		} else {
			console.log("No se seleccionaron imágenes.");
		}
	}

	/**
	 * Manejo de imagen principal
	 * @param $event
	 * @returns
	 */
	imageCropped(event: ImageCroppedEvent) {
		this.pictureCrop = event.base64;
	}

	imageLoaded(event: any) {}

	cropperReady() {}
	loadImageFailed() {}

	/**
	 * Manejador para imágen principal
	 * @param $event
	 * @returns
	 */
	public handleUploadPhoto(event: any) {
		this.imageChangedEvent = event;
		this.cropping = true;
	}

	/**
	 * Eliminar foto del formulario, galería
	 */
	public deletePhoto() {
		this.photo = [];
		this.stringPhoto = [];
		this.fileInput.nativeElement.value = "";
	}

	/**
	 * Eliminar foto main
	 */
	public deleteMainPhoto() {
		this.mainPhoto = undefined;
		this.mainStringPhoto = undefined;
		this.pictureCrop = undefined;
	}

	/**
	 * Push a array de imágenes eliminadas
	 * @param id
	 * @param index
	 */
	public deletePhotoCarrousel(id: number, index: number) {
		this.stringPhoto.splice(index, 1)[0];
		this.photosToDelete.push(id);
	}
}
